import { render } from "./VeelgesteldeVragenView.vue?vue&type=template&id=200c698b"
import script from "./VeelgesteldeVragenView.vue?vue&type=script&lang=js"
export * from "./VeelgesteldeVragenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__